import { render, staticRenderFns } from "./NoTips.vue?vue&type=template&id=6df64206&scoped=true&"
import script from "./NoTips.vue?vue&type=script&lang=js&"
export * from "./NoTips.vue?vue&type=script&lang=js&"
import style0 from "./NoTips.vue?vue&type=style&index=0&id=6df64206&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df64206",
  null
  
)

export default component.exports